import { Story } from '../../DocTypes';

export const dataDrivenButtonAccentStory: Story = {
  title: 'Data driven button accents',
  description: 'List with items having button accents that are styled by data',
  coreComponent: {
    html: `<tag-list
    primary-field='name'
    secondary-field='description'
    button-1='Start'
    button-1-accent-field='startAccent'
    button-1-icon='Clock'
    button-2='Stop'
    button-2-accent-field='stopAccent'
    button-2-icon='Clock'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        name: 'Project X',
        description: 'A project all about X',
        stopAccent: 'access'
      },
      {
        name: 'Project Y',
        description: 'A project all about Y',
        startAccent: 'access'
      },
      ,
      {
        name: 'Project Z',
        description: 'A project all about Z',
        startAccent: 'access'
      },
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
    primaryField='name'
    secondaryField='description'
    button1='Start'
    button1Accent-field='startAccent'
    button1Icon='Clock'
    button2='Stop'
    button2Accent-field='stopAccent'
    button2Icon='Clock'
    data={[
      {
        name: 'Project X',
        description: 'A project all about X',
        stopAccent: 'access'
      },
      {
        name: 'Project Y',
        description: 'A project all about Z',
        startAccent: 'access'
      },
      ,
      {
        name: 'Project Z',
        description: 'A project all about Z',
        startAccent: 'access'
      },
    ]}
  />`,
  },
};
